import styled from "styled-components";

export const ContentCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    position: relative;
    color: #EFEFEF;
    background-color: rgba(12, 22, 36, 0.75);
    border: 1px solid rgba(60, 140, 220, 0.35);
    border-radius: 6px;
    box-shadow: inset 0 0 12px rgba(30, 110, 200, 0.08), 0 0 8px rgba(20, 90, 180, 0.12);
    box-sizing: border-box;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 42px;
        left: 10px;
        right: 10px;
        height: 1px;
        background: linear-gradient(90deg, transparent, #3698ff, transparent);
        z-index: 1;
    }

    &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 16px;
        height: 16px;
        border-top: 1px solid #4096ff;
        border-left: 1px solid #4096ff;
        border-radius: 4px 0 0 0;
    }
    & .corner-br {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 16px;
        height: 16px;
        border-bottom: 1px solid #4096ff;
        border-right: 1px solid #4096ff;
        border-radius: 0 0 6px 0;
    }
`;

export const Title = styled.div`
    color: rgba(255, 255, 255, 0.8);
    padding: 10px;
    box-sizing: border-box;
    display: flex; 
    flex-direction: row;
    align-items: center;
`;

export const TitleCn = styled.div`
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 4px;
    white-space: nowrap;
`;

export const TitleEn = styled.div`
    font-size: 11px;
    font-weight: 100;
    letter-spacing: 2px;
    white-space: nowrap;
`;

export const TitleSeparator = styled.div`
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 1px;
    margin: 0px 10px ;
`;

export const TitleBorder = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
`;

export const BorderLeftCircle = styled.div`
    width: 3px;
    height: 3px;
    border-radius: 1.5px;
    background-color: rgba(255, 255, 255, 0.5);
    margin: 0px 5px 0px 0px;
`;

export const BorderLeftBlock = styled.div`
    height: 3px;
    width: 30px;
    border-radius: 1.5px;
    background-color: rgba(255, 255, 255, 0.5);
`;

export const BorderLine = styled.div`
    flex: 1 1 auto;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.5);
`;

export const BorderRightBlock = styled.div`
    height: 3px;
    width: 30px;
    border-radius: 1.5px;
    background-color: rgba(255, 255, 255, 0.5);
`;

export const Content = styled.div`
    flex: 1 1 auto;
`;

